const init = () => {
  multiCurrencySelector();
};

// Referenced from https://shopify.dev/themes/internationalization/multiple-currencies-languages#javascript-submission-of-the-localization-form

const multiCurrencySelector = () => {
  const countrySelector = document.querySelectorAll(
    '.shopify-localization-form select'
  );

  if (countrySelector.length === 0) {
    return false;
  }

  // @devs workaround to show the correctly selected currency by triggering a page refresh in the event that the user switches currency and subsequently hits the back button
  const perfEntries = performance.getEntriesByType('navigation');

  if (perfEntries[0].type === 'back_forward') {
    window.location.reload();
  }

  countrySelector.forEach(countryElem => {
    countryElem.addEventListener('change', event => {
      event.target.form.submit();
    });
  });
};

export const countrySelectorSelected = () => {
  const selectedCurrencyAttr = '[data-selected-currency]';
  const currencies = document.querySelectorAll(selectedCurrencyAttr);
  if (currencies.length === 0) {
    return false;
  }

  let countryValue = '';

  currencies.forEach(country => {
    if (country.selected) {
      countryValue = country.value;
    }

    return countryValue;
  });

  return countryValue;
};

export default init;
